import { useApolloClient } from '@apollo/client';
import { RequestCloudinaryUploadSignatureMutation, RequestCloudinaryUploadSignatureMutationVariables } from '@graphql/admin/generated/graphql.types';
import { requestCloudinaryUploadSignatureMutation } from '@graphql/admin/mutations';
import { useState } from 'react';

export function useUploadImage() {
  const apolloClient = useApolloClient();
  const [uploading, setUploading] = useState(false);

  const upload = async (file: string | File | Blob) => {
    setUploading(true);
    try {
      // @README the GQL operation is the same for admin and users
      const uploadSignatureResponse = await apolloClient.mutate<RequestCloudinaryUploadSignatureMutation, RequestCloudinaryUploadSignatureMutationVariables>({
        mutation: requestCloudinaryUploadSignatureMutation,
      });
      if (uploadSignatureResponse.data?.requestCloudinaryUploadSignature) {
        const uploadSignature = uploadSignatureResponse.data.requestCloudinaryUploadSignature;
        const formData = new FormData();
        formData.append('file', file);
        formData.append('timestamp', String(uploadSignature.timestamp));
        formData.append('signature', uploadSignature.signature);
        formData.append('public_id', uploadSignature.public_id);
        formData.append('api_key', process.env.CLOUDINARY_KEY);
        const response = await fetch(`https://api.cloudinary.com/v1_1/${process.env.CLOUDINARY_NAME}/image/upload`, {
          method: 'POST',
          body: formData,
        })
        const data = (await response.json()) as {
          url: string
          public_id: string
        }
        return data;
      } else {
        // unable to get cloudinary upload signature
        throw new Error('generic');
      }
    } catch (err) {
      throw err;
    } finally {
      setUploading(false);
    }
  }

  return [uploading, upload] as [boolean, typeof upload];
}